import React, { useState } from 'react';
import { Apify, ApifyParallel } from '../Apify';
import API from '../API';
import { Chartify, ChartCfgCard, ChartCfgDefault } from './Chart';
import { Card, CardBody } from 'reactstrap';
import { A, BlessLink, R } from '../routes';

import { T } from '../traks';
import I18N from '../I18N';
import ChangeArrow from './ChangeArrow';
import Countdown from './Countdown';
import ActionLink from './ActionLink';
import { SkinProvider } from '../skin';
import LogoAndInfo from './LogoAndInfo';

function card_wrap(href, onclick, delete_element, inner_render) {
	var Link;
	if (onclick) {
		Link = (props) => <ActionLink className="ad_game_card_link" on_click={onclick}>{props.children}</ActionLink>;
	} else {
		Link = (props) => <A className="ad_game_card_link" href={href}>{props.children}</A>;
	}
	return (
		<Card className="ad_game_card">
			<CardBody className="p-0">
				{delete_element()}
				<Link>
					{inner_render()}
				</Link>
			</CardBody>
		</Card>
	);
}

function get_value_pct_and_change(props) {
	const points = props.chart_data.points;
	if (points.length === 0) {
		return [
			null,
			null,
			null
		];
	}
	const start_val = points[0].value;
	const end_val = points[points.length-1].value;
	const pct = start_val > 0 ? ((end_val / start_val) - 1) * 100 : null;
	return [
		end_val,
		pct,
		end_val - start_val
	];
}

function get_pct(props) {
	return get_value_pct_and_change(props)[1];
}

function get_value(props) {
	return get_value_pct_and_change(props)[0];
}

function get_change(props) {
	return get_value_pct_and_change(props)[2];
}

function mk_change_element(props) {
	const pct = get_pct(props);
	return <ChangeArrow pct={pct} suffix="%"/>;
}

function Change(props) {
	const value = get_value(props);
	const change_money = get_change(props);
	const currency = props.chart_data.unit;
	return (
		<div>
			<div className="pl-3">
				<div className="ad_cardchart_changetext_size">
					{mk_change_element(props)}
				</div>
			</div>
			<div className="ad_cardchart_changetext pl-4">{I18N.floatval(value, 2)}&nbsp;{currency}</div>
			<div className="ad_cardchart_changetext pl-4">{I18N.floatval(change_money, 2)}&nbsp;{currency}</div>
			<div className="pt-3">
				{card_chart(props, true)}
			</div>
		</div>
	);
}

function plus_minus_line_fill_cfg(value) {
	var line_cfg, fill_cfg;
	if (value > 0) {
		line_cfg = {
			class_line_gradstop_x0: "ad_chart_line_game_positive_gradstop_x0",
			class_line_gradstop_x1: "ad_chart_line_game_positive_gradstop_x1",
		};
		fill_cfg = {
			class_fill_gradstop_x0: "ad_chart_fill_game_positive_gradstop_x0",
			class_fill_gradstop_x1: "ad_chart_fill_game_positive_gradstop_x1",
		};
	} else if (value < 0) {
		line_cfg = {
			class_line_gradstop_x0: "ad_chart_line_game_negative_gradstop_x0",
			class_line_gradstop_x1: "ad_chart_line_game_negative_gradstop_x1",
		};
		fill_cfg = {
			class_fill_gradstop_x0: "ad_chart_fill_game_negative_gradstop_x0",
			class_fill_gradstop_x1: "ad_chart_fill_game_negative_gradstop_x1",
		};
	} else {
		line_cfg = {
			class_line_gradstop_x0: "ad_chart_line_game_zero_gradstop_x0",
			class_line_gradstop_x1: "ad_chart_line_game_zero_gradstop_x1",
		};
		fill_cfg = {
			class_fill_gradstop_x0: "ad_chart_fill_game_zero_gradstop_x0",
			class_fill_gradstop_x1: "ad_chart_fill_game_zero_gradstop_x1",
		};
	}
	return [line_cfg, fill_cfg];
}

function card_chart(props, use_fill_gradient) {
	const { ChartComponent } = props;
	const pct = get_pct(props);
	const [line_cfg, fill_cfg] = plus_minus_line_fill_cfg(pct);
	var cfg = {...ChartCfgCard, ...line_cfg};
	if (use_fill_gradient) cfg = {...cfg, ...fill_cfg};
	return (
		<div className="ad_chart_card_outer">
			<div className="ad_chart_card_inner">
				<ChartComponent cfg={cfg}/>
			</div>
		</div>
	);
}

const stock_href_from_props = (props) => {
	if (props.range) {
		return R.href("/ticker/:exchange/:ticker?range=:range", {exchange: props.exchange, ticker: props.ticker, range: props.range});
	} else {
		return R.href("/ticker/:exchange/:ticker", {exchange: props.exchange, ticker: props.ticker});
	}
}


const StockCard = ApifyParallel(
	Chartify("stock").with_usage("item").with_chart_component_prop(),
	Apify("/z/stock_info").with_query_from_props((props) => ({exchange: props.exchange, ticker: props.ticker, lang: R.get_current_language()})).with_response_prop("stock_info")
).wrap((props) => {
	const href = stock_href_from_props(props);

	return card_wrap(href, null, () => null, () => (
			<React.Fragment>
				<div className="p-2">
					<LogoAndInfo add_ellipsis2name={true} logo_size={30} css_ticker="ad_card_chart_ticker" css_name="ad_card_chart_name" exchange={props.exchange} ticker={props.ticker} hasData={true} />
				</div>
				<Change {...props}/>
			</React.Fragment>
	));
});

function plus_minus_span(value, cls = "") {
	const value_fmt = I18N.floatval(Math.abs(value), 2);
	if (value > 0) {
		return <span className={`${cls} ad_growth_positive`}>+&nbsp;{value_fmt}</span>;
	} else if (value < 0) {
		return <span className={`${cls} ad_growth_negative`}>-&nbsp;{value_fmt}</span>;
	} else {
		return <span className={`${cls} ad_growth_zero`}>0</span>;
	}
}

const TinyStockCard = Chartify("stock").with_usage("item").with_chart_component_prop().wrap((props) => {
	const href = stock_href_from_props(props);

	const change_span = plus_minus_span(get_change(props));
	const value_span = <span>{I18N.floatval(get_value(props), 2)}</span>;
	const pct_span = <span>{plus_minus_span(get_pct(props))} %</span>;

	const line_cfg = plus_minus_line_fill_cfg(get_pct(props))[0]
	const { ChartComponent } = props;

	const cfg = {...ChartCfgDefault, ...line_cfg};

	return (
		<A href={href} className="ad_ticker_strip_a">
			<table className="ad_ticker_strip_table bg-color-white">
				<tbody className="d-flex flex-column px-3 py-2">
					<tr className="d-flex justify-content-between">
						<td className="txt-color-black pb-4">{props.ticker}<br></br><span className="font-s">{props.name}</span></td><td className="txt-color-black pb-4"></td>
						<td className="text-nowrap text-right ad_ticker_strip_text_right pb-4">{change_span} | {value_span}</td>
					</tr>
					<tr className="d-flex justify-content-between">
						<td className="ad_ticker_strip_text_big text-nowrap">{pct_span}</td>
						<td className="text-right w-100">
							<div style={{height:"1.8rem", maxHeight:"1.8rem"}}>
								<ChartComponent cfg={cfg}/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</A>
	);
});

const TinyPortfolioCard = Chartify("portfolio").with_usage("item").with_chart_component_prop().wrap((props) => {
	const href = R.href("/portfolio/:id", {id: props.id});

	const change_span = plus_minus_span(get_change(props));
	const value_span = <span>{I18N.floatval(get_value(props), 2)}</span>;
	const pct_span = plus_minus_span(get_pct(props));

	const line_cfg = plus_minus_line_fill_cfg(get_pct(props))[0]
	const { ChartComponent } = props;

	const cfg = {...ChartCfgDefault, ...line_cfg};

	return (
		<A href={href} className="ad_ticker_strip_a">
			<table className="ad_ticker_strip_table bg-color-white">
				<tbody className="d-flex flex-column px-3 py-2">
					<tr className="d-flex justify-content-between">
						<td className="txt-color-black pb-4">{props.name}</td>
						<td className="text-right ad_ticker_strip_text_right pb-4">{change_span} | {value_span}</td>
					</tr>
					<tr className="d-flex justify-content-between">
						<td className="ad_ticker_strip_text_big text-nowrap">{pct_span}</td>
						<td className="text-right w-100">
							<div style={{height:"1.8rem", maxHeight:"1.8rem"}}>
								<ChartComponent cfg={cfg}/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</A>
	);
});

const PortfolioCard = ApifyParallel(
	Chartify("portfolio").with_usage("item").with_chart_component_prop(),
	Apify("/z/portfolio_info").with_query_from_props((props) => ({id: props.id})).with_response_prop("portfolio_info")
).wrap((props) => {
	const href = R.href("/portfolio/:id", {id: props.id});

	const [confirm_delete_portfolio_id, set_confirm_delete_portfolio_id] = useState(0);


	let delete_portfolio_marker = ((del_portfolio_id) => () => {
		if (confirm_delete_portfolio_id === del_portfolio_id) {
			const do_delete = () => {
				API.post("/a/remove_portfolio", {id: props.id}, (ok) => {
					window.location.reload();
				});
			};
			const do_cancel = () => {
				set_confirm_delete_portfolio_id(0);
			};
			return (
				<div className="d-block p-3 text-center" style={{color: "black"}}>
					<div style={{background: "yellow"}} className="py-2">
						<span className="pr-3"><T><b>PERMANENTLY</b> delete?</T></span>
						<span className="ad_blue_link pr-3"><ActionLink on_click={do_delete}><T>Yes</T></ActionLink></span>
						<span className="ad_blue_link"><ActionLink on_click={do_cancel}><T>No</T></ActionLink></span>
					</div>
				</div>
			);
		} else {
			const confirm_delete = () => set_confirm_delete_portfolio_id(del_portfolio_id);
			return (
				<ActionLink on_click={confirm_delete}>
					<div className="ad_game_delete_marker text-right w-25">
						<img style={{maxWidth: "18px", maxHeight: "18px"}} alt="del portfolio" src="/gfx/remove-portfolio-icon-1.svg" />
					</div>
				</ActionLink>
			);
		}
	})(props.id);

	return card_wrap(href, null, delete_portfolio_marker, () => (
		<div>
			<div className="pt-4 pb-2 pl-3 ad_portfoliocard_heading">
				<span className="text-overflow-dynamic-container">
					<span className="text-overflow-dynamic-ellipsis ">
						{props.portfolio_info.Name}
					</span>
				</span>
			</div>
			<Change {...props}/>
		</div>
	));
});

const GameCard = ApifyParallel(
	Chartify("game").with_usage("item").with_chart_component_prop(),
	Apify("/z/game_info").with_query_from_props((props) => ({game_id: props.game_id, portfolio_id: props.portfolio_id})).with_response_prop("game_info")
).wrap((props) => {

	const { game_info } = props;

	const [confirm_delete_game_id, set_confirm_delete_game_id] = useState(0);

	const href = R.href("/game/:id", {id: props.game_id});
	var countdown;

	switch (game_info.State) {
	case "prestart":
		countdown = <span><T>Game starts in&nbsp;</T><Countdown end_time={game_info.StartTime}/></span>;
		break;
	case "started":
		countdown = <span><T>Game ends in&nbsp;</T><Countdown end_time={game_info.EndTime}/></span>;
		break;
	case "ended":
		countdown = <span><T>Game has ended</T></span>;
		break;
	default:
	}

	let active_marker = null;

	if (props.is_active) {
		active_marker = (
			<div className="ad_game_is_active_marker px-2">
				<T>Active</T>
			</div>
		);
	}

	let delete_game_marker = () => null;

	if(game_info.State !== 'ended' && (game_info.IsHostPortfolio === false || game_info.PlayerCount === 1)) {
		delete_game_marker = ((del_game_id) => () => {
			if (confirm_delete_game_id === del_game_id) {
				const do_delete = () => {
					API.post("/a/remove_portfolio", {id: props.portfolio_id}, (ok) => {
						window.location.reload();
					});
				};
				const do_cancel = () => {
					set_confirm_delete_game_id(0);
				};
				return (
					<div className="d-block p-3 text-center" style={{color: "black"}}>
						<div style={{background: "yellow"}} className="py-2">
							<span className="pr-3"><T><b>PERMANENTLY</b> delete game?</T></span>
							<span className="ad_blue_link pr-3"><ActionLink on_click={do_delete}><T>Yes</T></ActionLink></span>
							<span className="ad_blue_link"><ActionLink on_click={do_cancel}><T>No</T></ActionLink></span>
						</div>
					</div>
				);
			} else {
				const confirm_delete = () => set_confirm_delete_game_id(del_game_id);
				return (
					<ActionLink on_click={confirm_delete}>
						<div className="ad_game_delete_marker text-right">
							<img alt="del game" src="/gfx/remove-portfolio-icon-1.svg" />
						</div>
					</ActionLink>
				);
			}
		})(props.game_id);
	}

    const playerCount = game_info.PlayerCount - 1;

	return card_wrap(href, null, delete_game_marker, () => (
		<div>
            {game_info.GameType === 'pro' && (
                <div className='d-flex premium-banner pr-4 pl-2 py-2'>
                    <img src='https://static.aktiedysten.dk/gfx/premium_game.png' width={24} height={24} className='mr-1' alt='A cartoon sticker of a rocket ship blasting off' />
                    <T>Premium challenge</T>
                    <span className='text-right ml-auto pr-2'>
                        <T>{playerCount} invitations used</T>
                    </span>
                </div>
            )}
			<div className="px-4">
				{active_marker}
				<div className="text-center ad_game_card_title pt-4 pb-1">{game_info.Name}</div>
				<div className="text-center ad_game_card_subtitle pb-4">{countdown}</div>
				<table className="w-100">
					<tbody>
						<tr>
							<td className="text-center ad_game_card_tdleft">
								<div className="ad_game_card_th1 pt-3"><T>Number of players</T></div>
								<div className="ad_game_card_th2 pb-2">{game_info.PlayerCount}</div>
							</td>
							<td className="text-center ad_game_card_tdright">
								<div className="ad_game_card_th1 pt-3"><T>Your position</T></div>
								<div className="ad_game_card_th2 pb-2">{game_info.Placement || "-"}</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div className="ad_game_card_th1 pt-3"><T>Your development</T></div>
				<div>
					{mk_change_element(props)}
				</div>
			</div>
			<div>
				{card_chart(props, false)}
			</div>
		</div>
	));
});

const PublicGameCardImpl = Apify("/a/part_of_game")
	.with_query_from_props(props => ({game_id: props.Id}))
	.with_response_prop("is_part_of_game")
.wrap((props) => {
	const { skin, is_part_of_game, Id, State, Name, PlayerCount, StartTime, EndTime } = props;
	var href = R.href("/invite/:id", {id: Id});

	var col2, btntxt, btncls, subtitle;
	var subtitlecls = "text-center ad_game_card_subtitle pb-4";
	const gotogame = <T>Go to game</T>;
	const duration_seconds = props.EndTime - props.StartTime;
	const duration_days = Math.round(duration_seconds / (24*60*60));
	if (State === "prestart") {
		col2 = (
			<React.Fragment>
				<div className="ad_game_card_th1 pt-3"><T>Game starts in&nbsp;</T></div>
				<div className="ad_game_card_th2 pb-2"><Countdown end_time={StartTime}/></div>
			</React.Fragment>
		);
		subtitle = <React.Fragment><T>Duration</T>:&nbsp;<T>{duration_days} day(s)</T></React.Fragment>;
		if (is_part_of_game) {
			btntxt = gotogame;
		} else {
			btntxt = <T>Sign up</T>;
		}
		btncls = "ad_topbar_new_game ad_explore_market_button";
	} else if (State === "started") {
		col2 = (
			<React.Fragment>
				<div className="ad_game_card_th1 pt-3"><T>Game ends in &nbsp;</T></div>
				<div className="ad_game_card_th2 pb-2"><Countdown end_time={EndTime}/></div>
			</React.Fragment>
		);
		subtitle = <T>The game has begun</T>;
		subtitlecls += " ad_green";
		if (is_part_of_game) {
			btntxt = gotogame;
		} else {
			btntxt = <T>Join</T>;
		}
		btncls = "ad_topbar_new_game";
	} else {
		return null;
	}

	btncls += " my-4 px-4 py-2";

	return card_wrap(href, null, () => null, () => (
		<React.Fragment>
			{skin.render_public_game_card_header()}
			<div>
				<div className="px-4">
					<div className="text-center ad_game_card_title pt-4 pb-1">{Name}</div>
					<div className={subtitlecls}>{subtitle}</div>
					<table className="w-100">
						<tbody>
							<tr>
								<td className="text-center ad_game_card_tdleft">
									<div className="ad_game_card_th1 pt-3"><T>Number of players</T></div>
									<div className="ad_game_card_th2 pb-2">{PlayerCount}</div>
								</td>
								<td className="text-center ad_game_card_tdright">
									{col2}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				{skin.render_public_game_card_footer()}

				<div className="text-center">
					<BlessLink><div className={btncls} href={R.href("/game/:id", {id: Id})}>{btntxt}</div></BlessLink>
				</div>
			</div>
		</React.Fragment>
	));
});

const PublicGameCard = (props) => {
	return (
		<SkinProvider skin_id={props.SkinId}>
			<PublicGameCardImpl {...props}/>
		</SkinProvider>
	);
};

export { StockCard, TinyStockCard, TinyPortfolioCard, PortfolioCard, GameCard, PublicGameCard };



// WEBPACK FOOTER //
// ./src/c/ChartCard.js